/**
 * 用于Expansion中所有ExpansionPanel的显示模式
 */
export type SimExpansionDisplayMode = 'default' | 'flat';

/**
 * 用于Expansion中所有ExpansionPanelHeader的指示箭头显示位置
 */
export type SimExpansionTogglePosition = 'before' | 'after';

/**
 * 用于ExpansionPanel的展开和折叠状态
 */
export type SimExpansionPanelState = 'expanded' | 'collapsed';
